// extracted by mini-css-extract-plugin
export default {"container":"OZ-z","list":"PZ-z"};